import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const EndToEndSolutions = () => {
  const solutions = [
    {
      icon: '🔍',
      title: 'Site Selection',
      description: 'Expert guidance in choosing the perfect location for your needs',
      color: '#2180CE'
    },
    {
      icon: '💼',
      title: 'Buying Services',
      description: 'Comprehensive assistance in property acquisition and documentation',
      color: '#FFBE1D'
    },
    {
      icon: '🏷️',
      title: 'Selling Services',
      description: 'Marketing and negotiation support for optimal property sales',
      color: '#2180CE'
    },
    {
      icon: '🏗️',
      title: 'Development',
      description: 'Full-scale project development from planning to execution',
      color: '#FFBE1D'
    },
    {
      icon: '📋',
      title: 'Legal Compliance',
      description: 'Complete regulatory and documentation support',
      color: '#2180CE'
    },
    {
      icon: '🎯',
      title: 'Handover',
      description: 'Seamless property transfer with complete transparency',
      color: '#FFBE1D'
    }
  ];

  const benefits = [
    {
      icon: '⚡',
      title: 'Single Point of Contact',
      description: 'One team handling all your real estate requirements'
    },
    {
      icon: '🎓',
      title: 'Expert Team',
      description: 'Experienced professionals across all real estate domains'
    },
    {
      icon: '💯',
      title: 'Complete Transparency',
      description: 'Clear communication and honest dealings at every step'
    },
    {
      icon: '🤝',
      title: 'Long-term Partnership',
      description: 'Committed support beyond transaction completion'
    }
  ];

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', 
      minHeight: '100vh',
      paddingTop: '60px',
      paddingBottom: '80px'
    }}>
      <Container>
        {/* Hero Section */}
        <div className="text-center mb-5">
          <div style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #2180CE 0%, #1a6bb8 100%)',
            padding: '12px 30px',
            borderRadius: '50px',
            marginBottom: '20px',
            boxShadow: '0 4px 15px rgba(33, 128, 206, 0.3)'
          }}>
            <span style={{ color: 'white', fontWeight: 700, fontSize: '1rem' }}>
              🎯 COMPLETE SOLUTIONS
            </span>
          </div>
          
          <h1 style={{
            color: '#2180CE',
            fontWeight: 800,
            fontSize: '3.5rem',
            marginBottom: '1.5rem',
            lineHeight: '1.2',
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
          }}>
            End-to-End Real Estate Solutions
          </h1>
          
          <p style={{
            fontSize: '1.3rem',
            color: '#495057',
            maxWidth: '850px',
            margin: '0 auto 1rem',
            lineHeight: '1.8'
          }}>
            From site selection to handover, we offer comprehensive real estate solutions across Hyderabad.
          </p>
          
          <p style={{
            fontSize: '1.2rem',
            color: '#2180CE',
            fontWeight: 600
          }}>
            Your one-stop partner for buying, selling, and developing properties.
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="mb-5">
          <div className="text-center mb-4">
            <h2 style={{
              color: '#2180CE',
              fontWeight: 700,
              fontSize: '2.5rem',
              marginBottom: '1rem'
            }}>
              Our Comprehensive Services
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#6c757d' }}>
              Every step covered, every need fulfilled
            </p>
          </div>

          <Row className="g-4">
            {solutions.map((solution, index) => (
              <Col lg={4} md={6} key={index}>
                <Card style={{
                  border: 'none',
                  borderRadius: '20px',
                  boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
                  height: '100%',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  overflow: 'hidden',
                  position: 'relative'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.08)';
                }}>
                  <div style={{
                    height: '6px',
                    background: `linear-gradient(90deg, ${solution.color} 0%, ${solution.color}dd 100%)`,
                    width: '100%'
                  }} />
                  <Card.Body className="p-4">
                    <div style={{
                      fontSize: '3.5rem',
                      marginBottom: '1rem'
                    }}>
                      {solution.icon}
                    </div>
                    <h4 style={{
                      color: solution.color,
                      fontWeight: 700,
                      marginBottom: '0.8rem',
                      fontSize: '1.3rem'
                    }}>
                      {solution.title}
                    </h4>
                    <p style={{
                      color: '#6c757d',
                      marginBottom: 0,
                      fontSize: '1rem',
                      lineHeight: '1.6'
                    }}>
                      {solution.description}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        {/* Process Flow */}
        <Card style={{
          border: 'none',
          borderRadius: '25px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
          overflow: 'hidden',
          marginBottom: '3rem',
          background: 'white'
        }}>
          <Card.Body style={{ padding: '50px 40px' }}>
            <div className="text-center mb-4">
              <h2 style={{
                color: '#2180CE',
                fontWeight: 700,
                fontSize: '2.5rem',
                marginBottom: '1rem'
              }}>
                Seamless Journey
              </h2>
              <p style={{ fontSize: '1.1rem', color: '#6c757d' }}>
                A streamlined process from start to finish
              </p>
            </div>

            <div style={{
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '20px',
              marginTop: '40px'
            }}>
              {['Site Selection', 'Documentation', 'Development', 'Handover'].map((step, index) => (
                <React.Fragment key={index}>
                  <div style={{
                    textAlign: 'center',
                    position: 'relative'
                  }}>
                    <div style={{
                      width: '80px',
                      height: '80px',
                      borderRadius: '50%',
                      background: `linear-gradient(135deg, ${index % 2 === 0 ? '#2180CE' : '#FFBE1D'} 0%, ${index % 2 === 0 ? '#1a6bb8' : '#f0b000'} 100%)`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 15px',
                      boxShadow: `0 6px 20px ${index % 2 === 0 ? 'rgba(33, 128, 206, 0.3)' : 'rgba(255, 190, 29, 0.3)'}`,
                      fontSize: '1.5rem',
                      fontWeight: 700,
                      color: index % 2 === 0 ? 'white' : '#333'
                    }}>
                      {index + 1}
                    </div>
                    <div style={{
                      fontWeight: 600,
                      color: '#333',
                      fontSize: '1.1rem'
                    }}>
                      {step}
                    </div>
                  </div>
                  {index < 3 && (
                    <div style={{
                      width: '60px',
                      height: '4px',
                      background: 'linear-gradient(90deg, #2180CE 0%, #FFBE1D 50%, #2180CE 100%)',
                      borderRadius: '2px',
                      display: window.innerWidth < 768 ? 'none' : 'block'
                    }} />
                  )}
                </React.Fragment>
              ))}
            </div>
          </Card.Body>
        </Card>

        {/* Benefits Section */}
        <Card style={{
          border: 'none',
          borderRadius: '25px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
          overflow: 'hidden',
          marginBottom: '3rem'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #FFBE1D 0%, #f0b000 100%)',
            padding: '40px',
            textAlign: 'center'
          }}>
            <h2 style={{
              color: '#333',
              fontWeight: 800,
              fontSize: '2.5rem',
              marginBottom: '0.5rem'
            }}>
              Why Choose Nakshatra Infra?
            </h2>
            <p style={{
              color: '#555',
              fontSize: '1.1rem',
              marginBottom: 0
            }}>
              The advantages of partnering with us
            </p>
          </div>
          
          <Card.Body style={{ padding: '50px 40px' }}>
            <Row className="g-4">
              {benefits.map((benefit, index) => (
                <Col md={6} key={index}>
                  <div style={{
                    display: 'flex',
                    gap: '20px',
                    padding: '30px',
                    background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
                    borderRadius: '15px',
                    border: '2px solid #e9ecef',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    height: '100%'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#2180CE';
                    e.currentTarget.style.transform = 'scale(1.03)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(33, 128, 206, 0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#e9ecef';
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                    <div style={{
                      fontSize: '3rem',
                      flexShrink: 0
                    }}>
                      {benefit.icon}
                    </div>
                    <div>
                      <h5 style={{
                        color: '#2180CE',
                        fontWeight: 700,
                        marginBottom: '0.5rem',
                        fontSize: '1.3rem'
                      }}>
                        {benefit.title}
                      </h5>
                      <p style={{
                        color: '#6c757d',
                        marginBottom: 0,
                        fontSize: '1rem',
                        lineHeight: '1.6'
                      }}>
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>

        {/* Call to Action */}
        <Card style={{
          border: 'none',
          borderRadius: '25px',
          background: 'linear-gradient(135deg, #2180CE 0%, #1a6bb8 100%)',
          color: 'white',
          boxShadow: '0 15px 50px rgba(33, 128, 206, 0.3)'
        }}>
          <Card.Body className="text-center" style={{ padding: '60px 40px' }}>
            <h2 style={{
              fontWeight: 800,
              fontSize: '2.5rem',
              marginBottom: '1rem'
            }}>
              Let's Build Your Real Estate Success Together
            </h2>
            <p style={{
              fontSize: '1.2rem',
              marginBottom: '2.5rem',
              opacity: 0.95,
              maxWidth: '700px',
              margin: '0 auto 2.5rem'
            }}>
              Experience hassle-free real estate solutions with Nakshatra Infra. 
              Your trusted partner in Hyderabad's property market.
            </p>
            <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a href="/contact" style={{
                background: '#FFBE1D',
                color: '#333',
                padding: '18px 40px',
                borderRadius: '12px',
                fontWeight: 700,
                fontSize: '1.1rem',
                textDecoration: 'none',
                display: 'inline-block',
                boxShadow: '0 6px 20px rgba(255, 190, 29, 0.4)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-3px)';
                e.target.style.boxShadow = '0 8px 25px rgba(255, 190, 29, 0.5)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 6px 20px rgba(255, 190, 29, 0.4)';
              }}>
                🚀 Get Started Today
              </a>
              <a href="/plot-sales" style={{
                background: 'rgba(255,255,255,0.15)',
                color: 'white',
                padding: '18px 40px',
                borderRadius: '12px',
                fontWeight: 700,
                fontSize: '1.1rem',
                textDecoration: 'none',
                display: 'inline-block',
                border: '2px solid rgba(255,255,255,0.3)',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.25)';
                e.target.style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.15)';
                e.target.style.transform = 'translateY(0)';
              }}>
                🏘️ Explore Properties
              </a>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default EndToEndSolutions;